/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './scroll-to-top.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory';
import * as i3 from '@angular/material/core';
import * as i4 from '@angular/material/button';
import * as i5 from '@angular/cdk/platform';
import * as i6 from '@angular/cdk/a11y';
import * as i7 from '../../../../../../$$_gendir/node_modules/@angular/material/icon/typings/index.ngfactory';
import * as i8 from '@angular/material/icon';
import * as i9 from '@angular/common';
import * as i10 from '../../../../../../app/modules/shared/components/scroll-to-top/scroll-to-top.component';
import * as i11 from '../../../../../../app/services/log.service';
const styles_ScrollToTopComponent:any[] = [i0.styles];
export const RenderType_ScrollToTopComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ScrollToTopComponent,data:{}});
function View_ScrollToTopComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),9,'button',[['class',
      'app-action-scroll-top mat-fab'],['color','primary'],['mat-fab','']],[[8,'disabled',
      0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.scrollToTop()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MatButton_0,i2.RenderType_MatButton)),i1.ɵdid(1,16384,(null as any),0,
      i3.MatPrefixRejector,([] as any[]),(null as any),(null as any)),i1.ɵdid(2,180224,
      (null as any),0,i4.MatButton,[i1.Renderer2,i1.ElementRef,i5.Platform,i6.FocusMonitor],
      {color:[0,'color']},(null as any)),i1.ɵdid(3,16384,(null as any),0,i4.MatFab,
      [[2,i4.MatButton],[8,(null as any)]],(null as any),(null as any)),(_l()(),i1.ɵted(-1,
      0,['\n  '])),(_l()(),i1.ɵeld(5,0,(null as any),0,3,'mat-icon',[['class','mat-icon'],
      ['role','img']],(null as any),(null as any),(null as any),i7.View_MatIcon_0,
      i7.RenderType_MatIcon)),i1.ɵdid(6,16384,(null as any),0,i3.MatPrefixRejector,
      ([] as any[]),(null as any),(null as any)),i1.ɵdid(7,638976,(null as any),0,
      i8.MatIcon,[i1.Renderer2,i1.ElementRef,i8.MatIconRegistry,[8,(null as any)]],
      (null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['keyboard_arrow_up'])),(_l()(),
      i1.ɵted(-1,0,['\n']))],(_ck,_v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    _ck(_v,7,0);
  },(_ck,_v) => {
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
  });
}
export function View_ScrollToTopComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_ScrollToTopComponent_1)),i1.ɵdid(1,16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i10.ScrollToTopComponent = _v.component;
    const currVal_0:any = _co.showScrollToTop;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_ScrollToTopComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'scroll-to-top',
      ([] as any[]),(null as any),[['window','scroll']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:scroll' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).checkShowScrollToTop($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_ScrollToTopComponent_0,RenderType_ScrollToTopComponent)),i1.ɵdid(1,4308992,
      (null as any),0,i10.ScrollToTopComponent,[i11.LogService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const ScrollToTopComponentNgFactory:i1.ComponentFactory<i10.ScrollToTopComponent> = i1.ɵccf('scroll-to-top',
    i10.ScrollToTopComponent,View_ScrollToTopComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9zY3JvbGwtdG8tdG9wL3Njcm9sbC10by10b3AuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9zY3JvbGwtdG8tdG9wL3Njcm9sbC10by10b3AuY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9tb2R1bGVzL3NoYXJlZC9jb21wb25lbnRzL3Njcm9sbC10by10b3Avc2Nyb2xsLXRvLXRvcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9zY3JvbGwtdG8tdG9wL3Njcm9sbC10by10b3AuY29tcG9uZW50LnRzLlNjcm9sbFRvVG9wQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGJ1dHRvbiAqbmdJZj1cInNob3dTY3JvbGxUb1RvcFwiIG1hdC1mYWIgY29sb3I9XCJwcmltYXJ5XCIgY2xhc3M9XCJhcHAtYWN0aW9uLXNjcm9sbC10b3BcIiAoY2xpY2spPVwic2Nyb2xsVG9Ub3AoKVwiPlxuICA8bWF0LWljb24+a2V5Ym9hcmRfYXJyb3dfdXA8L21hdC1pY29uPlxuPC9idXR0b24+XG4iLCI8c2Nyb2xsLXRvLXRvcD48L3Njcm9sbC10by10b3A+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFBc0Y7TUFBQTtNQUFBO0lBQUE7SUFBdEY7RUFBQSx1REFBQTsyQkFBQSxrREFBQTtNQUFBO01BQUEsMENBQUE7TUFBQSxrRUFBOEc7TUFBQSxhQUM1RztNQUFBOzJCQUFBLFVBQUE7TUFBQSxrREFBQTtpQkFBQTtNQUFBLDZCQUFVLDZDQUE0QjthQUFBO0lBREE7SUFBeEMsV0FBd0MsU0FBeEM7SUFDRTs7SUFERjtJQUFBLFdBQUEsU0FBQTs7OztvQkFBQTtNQUFBLHFDQUFBO29CQUFBLG1DQUVTO01BQUE7O0lBRkQ7SUFBUixXQUFRLFNBQVI7Ozs7b0JDQUE7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLHVFQUFBO01BQUE7O1FBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/scroll-to-top/scroll-to-top.component.ngfactory.ts